import React, { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { LanguageProvider } from "./i18n/LanguageContext";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Services from "./components/Services";
import VisionSection from "./components/VisionSection";
import About from "./components/About";
import Portfolio from "./components/Portfolio";
import Investors from "./components/Investors";
import FAQ from "./components/FAQ";
import TeamSection from "./components/TeamSection";
import FinalCTA from "./components/FinalCTA";
import Footer from "./components/Footer";
import AdminDashboard from "./components/AdminDashboard";
import ContactModal from "./components/ContactModal";
import LoginModal from "./components/LoginModal";

// Portal Components
import { AuthProvider } from "./components/portal/AuthContext";
import PortalLogin from "./components/portal/PortalLogin";
import AuthCallback from "./components/portal/AuthCallback";
import InvestorDashboard from "./components/portal/InvestorDashboard";
import CompanyDashboard from "./components/portal/CompanyDashboard";

const LandingPage = () => {
  const [isContactOpen, setIsContactOpen] = useState(false);
  const [isLoginOpen, setIsLoginOpen] = useState(false);

  return (
    <div className="min-h-screen bg-background">
      <Navbar 
        onOpenContact={() => setIsContactOpen(true)} 
        onOpenLogin={() => setIsLoginOpen(true)}
      />
      <Hero onOpenContact={() => setIsContactOpen(true)} />
      <Services />
      <div id="ibv" />
      <VisionSection />
      <Portfolio />
      <Investors onOpenContact={() => setIsContactOpen(true)} />
      <About />
      <FAQ onOpenContact={() => setIsContactOpen(true)} />
      <TeamSection />
      <FinalCTA onOpenContact={() => setIsContactOpen(true)} />
      <Footer />
      
      {/* Modals */}
      <ContactModal isOpen={isContactOpen} onClose={() => setIsContactOpen(false)} />
      <LoginModal isOpen={isLoginOpen} onClose={() => setIsLoginOpen(false)} />
    </div>
  );
};

// Portal Router - handles session_id detection
const PortalRouter = () => {
  const location = useLocation();
  
  // Check URL fragment for session_id - handle before ProtectedRoute runs
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      <Route path="/login" element={<PortalLogin />} />
      <Route path="/callback" element={<AuthCallback />} />
      <Route path="/investor" element={<InvestorDashboard />} />
      <Route path="/company" element={<CompanyDashboard />} />
      <Route path="/*" element={<PortalLogin />} />
    </Routes>
  );
};

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/admin" element={<AdminDashboard />} />
          <Route 
            path="/portal/*" 
            element={
              <AuthProvider>
                <PortalRouter />
              </AuthProvider>
            } 
          />
          <Route path="/*" element={<LandingPage />} />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
